<template>
  <div class="flex flex-row gap-8">
    <div class="flex flex-row gap-8 flex-wrap items-center w-fit">
      <div
        v-for="(text, index) in featuredFilterGroups"
        :key="'featuredCategories' + index"
        class="hidden md:flex gap-8 items-center"
      >
        <FilterInputButton
          type="button"
          bg-color="checked"
          filter-id=""
          :checked="true"
          :discernible-text="text + 'valt, öppna mer filter'"
          @on-clicked="emit('moreFiltersDrawer')"
        >
          <template #label>
            {{ text }}
          </template>
        </FilterInputButton>
        <div :class="dividerClass" />
      </div>

      <div
        v-for="(filter, index) in filterStore.featuredFilters"
        :key="filter?.filterId"
        class="hidden md:flex gap-8 items-center"
      >
        <FilterInputButton
          :test-id="'button-' + filter?.name"
          :filter-id="filter?.filterId"
          :checked="filterStore.isFilterActiveById[filter?.filterId ?? '']"
          :discernible-text="filter?.name"
          @on-clicked="onFeaturedFilterToggleClicked(filter?.filterId)"
        >
          <template #label>{{ filter?.name }}</template>
          <template v-if="filter?.iconName" #iconBefore>
            <nuxt-icon
              :name="filter?.iconName"
              class="text-24"
              aria-hidden="true"
            />
          </template>
        </FilterInputButton>
        <div
          v-if="isLastFeaturedFilterOfItsType(index, filter?.filterId)"
          :class="dividerClass"
        />
      </div>

      <FilterInputButton
        type="button"
        discernible-text="Öppna mer filter"
        @on-clicked="emit('moreFiltersDrawer')"
      >
        <template #iconBefore>
          <div class="inline-block md:hidden">
            <nuxt-icon
              name="sliders-filter"
              :class="nuxtIconClass"
              aria-hidden="true"
            />
          </div>
        </template>
        <template #label>
          <div class="block md:hidden">Filter</div>
          <div class="hidden md:inline-block">Mer filter</div>
        </template>
        <template #iconAfter>
          <div class="hidden md:inline-block">
            <nuxt-icon
              name="sliders-filter"
              :class="nuxtIconClass"
              aria-hidden="true"
            />
          </div>
        </template>
      </FilterInputButton>
    </div>
    <FilterInputButton
      type="button"
      class-list="ml-auto"
      discernible-text="Öppna mer sorteringsalternativ"
      @on-clicked="emit('sortingDrawer')"
    >
      <template #label>
        <div class="align-bottom">{{ filterStore.sortMode }}</div>
      </template>
      <template #iconAfter>
        <div>
          <nuxt-icon
            name="sort"
            :class="nuxtIconClass"
            aria-label="sorterings ikon"
          />
        </div>
      </template>
    </FilterInputButton>
  </div>
</template>

<script setup lang="ts">
const filterStore = useFilterStore();
const emit = defineEmits(['moreFiltersDrawer', 'sortingDrawer']);

const nuxtIconClass = 'inline-block align-middle';
const dividerClass =
  'hidden md:inline-block bg-surface-secondary w-4 h-32 rounded-full align-middle';

const featuredFilterGroups = computed(() =>
  filterStore.filters
    .map((filterGroup) =>
      filterStore.getFeaturedGroupDisplayText(filterGroup.title),
    )
    .filter((text) => text !== null && text !== undefined),
);

const onFeaturedFilterToggleClicked = (filterId?: string) => {
  filterStore.toggle(filterId);
};

const isLastFeaturedFilterOfItsType = (
  iterationIndex: number,
  filterId?: string,
) => {
  if (!filterId) {
    return false;
  }

  const filterGroupTitle = filterStore.filterGroupTitleByFilterIdMap[filterId];

  // Is last element
  if (iterationIndex === filterStore.featuredFilters.length - 1) {
    return true;
  }

  const nextFilter = filterStore.featuredFilters[iterationIndex + 1];
  const nextFilterGroupTitle =
    filterStore.filterGroupTitleByFilterIdMap[nextFilter?.filterId ?? ''];

  // Next element has a different category
  if (nextFilterGroupTitle !== filterGroupTitle) {
    return true;
  }

  return false;
};
</script>
